import { getNameInitials } from '@/lib';
import { cn, useI18n, useImgSrcWithFallback } from '@nosinovacao/nosid-mfe-common';
import { type ProfilePictureProps } from './props';

export function ProfilePictureWooDark({
  size,
  name,
  src: originalSrc,
  className,
}: Readonly<ProfilePictureProps>) {
  const { t } = useI18n();
  const { handleError, src, isFallback, handleLoad, isLoading } = useImgSrcWithFallback(
    originalSrc ?? null,
    '/images/nos/profile-pic-fallback.svg',
  );

  return (
    <div className={cn('relative isolate', className)} style={{ width: size, height: size }}>
      {isFallback || isLoading ? (
        <div
          aria-label={t('Common.ProfilePictureAlt', { name: name }).toString()}
          style={{ width: size, height: size }}
          className={cn(
            'absolute inset-0 z-10 grid shrink-0 place-items-center overflow-hidden rounded-full bg-nos-neutral-900 text-nos-neutral-0 desktop-md:bg-woo-green desktop-md:text-nos-neutral-1000',
          )}
        >
          <span className="select-none font-bold font-ui-8">{getNameInitials(name ?? '')}</span>
        </div>
      ) : null}
      {isFallback ? null : (
        <img
          className="shrink-0 rounded-full border-2 border-nos-neutral-700"
          src={src}
          alt={t('Common.ProfilePictureAlt', { name: name }).toString()}
          onError={handleError}
          onLoad={handleLoad}
          width={size}
          height={size}
        />
      )}
    </div>
  );
}
